/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExportResponse } from '../models/ExportResponse';
import type { WbhExportRequest } from '../models/WbhExportRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WbhExportControllerService {

  /**
   * Create new export
   * @returns ExportResponse Export successfully created
   * @throws ApiError
   */
  public static createExport({
requestBody,
}: {
requestBody: WbhExportRequest,
}): CancelablePromise<ExportResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/export',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
